import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setTitle, setReportTitle, setPoTitle } from './actions';
import * as shapes from './shapes';

class Title extends Component {
  constructor(props) {
    super(props);
    props.setTitle(props.children);
  }
  render() { return null; }
}

Title.propTypes = {
  children: shapes.title.isRequired,
  setTitle: shapes.handler.isRequired,
  namespace: PropTypes.oneOf(['report', 'main', 'po']), // eslint-disable-line react/no-unused-prop-types
};

Title.defaultProps = {
  namespace: 'main',
};

const mapDispatchToProps = { setTitle, setReportTitle, setPoTitle };

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const props = { ...ownProps, ...stateProps, ...dispatchProps };

  if (props.namespace === 'report') {
    props.setTitle = props.setReportTitle;
  } else if (props.namespace === 'po') {
    props.setTitle = props.setPoTitle;
  } else {
    props.setTitle = props.setTitle;
  }

  return props;
};

export default connect(null, mapDispatchToProps, mergeProps)(Title);
